import React from 'react';
import { Highlight } from 'react-instantsearch-dom';

import {
  Card,
  Typography,
  CardContent,
  CardActions,
  Button,
}
from '@material-ui/core';

const isMobile = window.innerWidth < 450;

export default function CreativeCard(props) {
  const { hit, onGetCode } = props;
  const cardStyle = isMobile ? {
    width: '100%',
    //height: hit.Height + 100,
    marginBottom: 10,
    position: 'relative',
  } : {
    width: hit.Width + 20,
    //height: hit.Height + 20 + 100,
    marginBottom: 10,
    marginLeft: 10,
    position: 'relative',
  };
  const imageHolderStyle = {
    textAlign: 'center',
  };

  const IframeBanner = () => (
    <iframe
          title={hit.CreativeName}
          src={`https://cdn.banhq.com${hit.CreativeURL}`}
          width={hit.Width}
          height={hit.Height}
          scrolling="no"
          frameBorder="0"
          style={{ display: 'block', margin: '10px auto' }}
        />
  );

  const LegacyBanner = () => (
    <img src={hit.CreativeURL}
       width={hit.Width}
       height={hit.Height}
       alt={hit.CreativeName}/>
  );

  return (
    <Card style={cardStyle}>
      <div style={imageHolderStyle}>
      { hit.ProgramType==="Legacy"?<LegacyBanner/>:
        <IframeBanner/>
      }
      </div>
      <CardContent>
        <Typography color="textPrimary" size="small" gutterBottom>
          <Highlight attribute="CreativeName" hit={hit} />
        </Typography>
        <Typography color="textSecondary">{hit.SiteTag}</Typography>
      </CardContent>
      <CardActions>
        <Button color="primary" onClick={onGetCode(hit)}>
          GET CODE
        </Button>
      </CardActions>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/components/CreativeCard.js